import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable, retry, take, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AppInterface } from '../../interfaces/app.interface';

@Injectable({
  providedIn: 'root',
})
export class AppFinderApiService {
  private appsEndpoint = '/me/appFinder';
  constructor(
    private http: HttpClient,
  ) {}

  public getApps(_getActiveApps?: boolean, getTranslations = false): Observable<AppInterface[]> {
    let params = new HttpParams();
    if (_getActiveApps !== undefined) {
      params = params.set('getActiveApps', _getActiveApps.toString());
    }
    if (getTranslations) {
      params = params.set('getTranslations', true);
    }

    return this.http
      .get<AppInterface[]>(`${environment.baseUrl}${this.appsEndpoint}`, {
        params: params,
      })
      .pipe(
        take(1),
        retry(3),
        catchError((error) => {
          console.error('AppFinder API failed after retries:', error);
          return throwError(
            () => new Error('Sorry, we couldn’t load your apps. Please try again later.'),
          );
        }),
      );
  }
}
